import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedToken = localStorage.getItem("access_token");
    return storedToken ? { token: storedToken } : null;
  });
  

  useEffect(() => {
    const storedToken = localStorage.getItem("access_token");
    if (storedToken && !user) {
      setUser({ token: storedToken });
    }
  }, []);

  const login = (userData) => {
    localStorage.setItem("access_token", userData.token);
    localStorage.setItem("login_success", "true");
    setUser(userData);
    window.location.reload(); 
  };
  

  const logout = () => {
    localStorage.setItem("logout_success", "true"); 
    localStorage.removeItem("access_token");
    setUser(null);
    window.location.reload(); 
  };
  

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
